import React, { useState } from "react";
import cross from "../assests/image/img/cross_r.webp";
import { countries } from "../utils/Constants";

export default function ZohoLeadForm({ onClose }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    jobTitle: "",
    email: "",
    mobile: "",
    company: "",
    city: "",
    state: "",
    country: "",
    description: "",
  });

  const validation = (formData) => {
    let err = "";
    if (formData?.firstName.trim() === "") {
      err = { ...err, firstName: "This Field is Required" };
    }
    if (formData?.lastName.trim() === "") {
      err = { ...err, lastName: "This Field is Required" };
    }
    if (formData?.email.trim() === "") {
      err = { ...err, email: "This Field is Required" };
    }
    if (
      formData?.mobile.trim().length < 10 ||
      formData?.mobile.trim().length > 10
    ) {
      err = { ...err, mobile: "Invalid Mobile no" };
    }
    return err;
  };

  const [err, setErr] = useState({});

  const handleSubmit = (e) => {
    debugger;
    e.preventDefault();
    const generatedError = validation(formData);

    if (generatedError == "") {
      e.target.submit();
    } else {
      setErr(generatedError);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <section
      className="toggle-form active"
      style={{
        maxHeight: "120vh",
        overflowY: "auto",
      }}
    >
      <div className="formwrap px-4 pt-4">
        <div className="icon-close pos-a" onClick={onClose}>
          <img src={cross} alt="Close Button" loading="lazy" />
        </div>
        <div className="contact-wrap">
          <div
            className="contact-form"
            style={{ padding: "10px", boxShadow: "none" }}
          >
            <div className="section-title">
              <h2 className="mb-2">We are here to assist you</h2>
            </div>
            <div
              id="crmWebToEntityForm"
              className="zcwf_lblRight crmWebToEntityForm"
              style={{
                backgroundColor: "#F2C7C7",
                color: "black",
                padding: "20px",
              }}
            >
              <form
                // id="webform190127000004042114"
                action="https://crm.zoho.in/crm/WebToLeadForm"
                method="POST"
                acceptCharset="UTF-8"
                onSubmit={handleSubmit}
              >
                {/* Hidden Zoho fields */}
                <input
                  type="hidden"
                  name="xnQsjsdp"
                  value="05cb739cd442efefc61546dc7e64d41ba2fa660eba202a57af33139deea44076"
                />
                <input type="hidden" name="zc_gad" id="zc_gad" />
                <input
                  type="hidden"
                  name="xmIwtLD"
                  value="13fc3bd044d62f33ae1d6d0126a027b8ef3ea25d23f24d51904a8de156141fff6caee1945aef678f48febcf05c5355c5"
                />
                <input type="hidden" name="actionType" value="TGVhZHM=" />
                <input type="hidden" name="returnURL" value="null" />
                <input type="hidden" id="ldeskuid" name="ldeskuid" />
                <input type="hidden" id="LDTuvid" name="LDTuvid" />

                <h2 style={{ fontFamily: "Calibri", marginBottom: 15 }}>
                  Connect with Us
                </h2>

                <div className="row mb-2 pb-2">
                  {/* First Name */}
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="firstName"
                        className="form-control"
                        placeholder="First Name*"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                      {err.firstName && (
                        <div className="help-block with-errors">
                          {err.firstName}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="lastName"
                        className="form-control"
                        placeholder="Last Name*"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                      {err.lastName && (
                        <div className="help-block with-errors">
                          {err.lastName}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email*"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {err.email && (
                        <div className="help-block with-errors">
                          {err.email}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Mobile */}
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="mobile"
                        className="form-control"
                        placeholder="Mobile*"
                        value={formData.mobile}
                        onChange={handleChange}
                        maxLength={10}
                      />
                      {err.mobile && (
                        <div className="help-block with-errors">
                          {err.mobile}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Job Title */}
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="jobTitle"
                        className="form-control"
                        placeholder="Job Title"
                        value={formData.jobTitle}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Company */}
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="company"
                        className="form-control"
                        placeholder="Company"
                        value={formData.company}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Country */}
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group w-100">
                      <select
                        name="country"
                        value={formData.country}
                        className="form-control"
                        onChange={handleChange}
                      >
                        <option value="">Select your country</option>
                        {countries.map((country, index) => (
                          <option key={index} value={country.value}>
                            {country.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* State */}
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="state"
                        className="form-control"
                        placeholder="State"
                        value={formData.state}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* City */}
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="city"
                        className="form-control"
                        placeholder="City"
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Description */}
                  <div className="col-12">
                    <div className="form-group">
                      <textarea
                        name="description"
                        className="form-control"
                        placeholder="Description"
                        value={formData.description}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    <button
                      type="submit"
                      className="formsubmit zcwf_button default-btn border-radius"
                    >
                      Submit    
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
